import { styled } from '../../../core/theme/styled';

const providerLogoWidth = '40px';

export const IconContainer = styled.div`
  position: relative;
  width: 160px;
`;

export const ProviderLogoContainer = styled.div`
  position: absolute;
  left: calc(50% - (${providerLogoWidth} / 2 + 1px));
  top: 10%;
`;

export const ProviderLogo = styled.img`
  width: ${providerLogoWidth};
`;

export const TruncatedText = styled.div`
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
